<template>
  <div class="basic-block block-three-year" :style="styles">
    <div class="content-wrap">
      <div class="block-three-year__inner">
        <img :src="`${path}title_3nen.png`" alt="" class="block-three-year__headline-img" />
        <div class="year-list">
          <ul class="year-list_ul">
            <li class="year-list_li">
              <span class="year-list_when"><img class="year-list_whenimg" :src="`${path}title_lastyear.png`" alt=""></span>
              <span class="year-list_text">昨年は「集中する」をキーワードとした年になったでしょう。…</span>
            </li>
            <li class="year-list_li">
              <span class="year-list_when"><img class="year-list_whenimg" :src="`${path}title_thisyear.png`" alt=""></span>
              <span class="year-list_text">広い視野を心がけると、よい運気を引き寄せるでしょう。…</span>
            </li>
            <li class="year-list_li">
              <span class="year-list_when"><img class="year-list_whenimg" :src="`${path}title_nextyear.png`" alt=""></span>
              <span class="year-list_text">来年は「思いやり」がキーワードの年になります。…</span>
            </li>
          
          </ul>
        </div>
        <lp-base-button label="3年間の運気を占う" design="fill" :color-scheme="colorScheme" @clicked="clicked" />
       
      </div>

    
     
    </div>
    <img :src="`${path}line_ashiato02.png`" alt="" class="ashiato-line" />
  </div>
  

</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton';


export default {
  name: 'BlockAboutSlider',
  components: {
    LpBaseButton,

  },
  props: {
    targetInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    colorScheme: {
      type: Object,
      default() {
        return {};
      },
    },
    lpId: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    styles() {
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      };
    },
  },
  methods: {
    clicked() {
      window.gtag('event', 'click', {
        event_category: `LP${this.lpId}-free-shindan-button`,
      });
      location.href = this.$handoverParams(`/products/44/0001/input`);
    },
  },
  data() {
    return {
      path: '/static/img/recommend/lp/somarimone/products/',
      
     
    };
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../../sass/commons/commonVariables.scss';

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

// 上限付きのレスポンシブなサイズを返す（$size は、width = 375px 時の大きさ）
@function responsive-size($size) {
  @return Min(($size / 375) * 100vw, $size * 1.3px );
}

.block-three-year {
  position: relative;
  background: #fcece1;
  padding: 40px 0 78px;
  &__inner{
    @include mq('w580'){
      padding-top: 48px;
    }
  }

  &__headline {
    font-weight: 600;
    font-size: responsive-size(20);
    line-height: 1.5;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0 0 8px;
  }
  &__headline-img {
    display: block;
    width: 100%;
    max-width: 100%;
    margin: 20px auto 24px;

  }
  &__profile {
    display: flex;
    align-items: center;
    max-width: 480px;
    margin: 0 auto 16px;
  }
  &__profile-img {
    flex: 0 1 160px;
    width: responsive-size(160);
    max-width: 200px;
  }

  &__sliderarea {
    margin: 0 0 24px;
    .swiper-slide {
      padding: 0 20px;
    }
  }
  &__slider-card {
    display: block;
    width: 100%;
    max-width: 480px;
    margin: auto;
  }
  &__free {
    font-weight: 600;
    font-size: responsive-size(20);
    line-height: 1.5;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0 0 24px;
  }
  .year-list {
    padding: 0 20px;
    margin-bottom: 24px;
}
  .year-list_ul{
   
  }
  .year-list_li{
    border: 1px solid $l_col_keycolor;
    overflow: hidden;

    background: #fff;
    min-height: 100px;

    display: flex;
    align-items: stretch;
    border-bottom: none;
    &:first-child{
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }
    &:last-child{
      border-bottom:1px solid $l_col_keycolor ;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
    }
  }
  .year-list_when{
   background: #fefaf0;
   padding: 40px 0;
   min-width: 40px;
  }
  .year-list_whenimg{
    width: 36px;
  }

  .year-list_text{
    background: #fff;
    max-width: 355px;
    padding: 16px;
    @include mq('w580'){
      max-width: 100%;
    }
  }

  .ashiato-line{
    position: absolute;
    bottom: -50px;
    width:100%;
    z-index: 1;
    @include mq('w580'){
      bottom: -110px;
      }
  }

  .baseButton {
    width: 72%;
    max-width: 340px;
    margin: auto;
    /deep/ {
      .baseButton__button {
        font-size: responsive-size(18);
        font-weight: 600;
        padding: 13.5px 32px;
        min-width: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/somarimone/partials/BlockThreeYears.vue